import { Routes, Route, Outlet } from 'react-router';
import { Layout, Profile } from '@/features/profile';

export const Router = () => (
  <Routes>
    <Route path="/*" element={<Layout />}>
      <Route index element={<Profile />} />
    </Route>
  </Routes>
);
